<div class="full-vh-container">
    <mat-card>
        <div class="panel__header">
            <span class="panel__header__title">{{'Average wear rates used in Forecasting' | translate | async}}</span>
        </div>
        <div class="row ">
            <div class="col-lg-12">

                <mat-form-field class="col-lg-4">
                    <input matInput #customerAutoCompleteInput (focus)="focus(1)" placeholder="{{'Customer' | translate | async}}" required
                        aria-label="customer" [matAutocomplete]="autoCustomer" [formControl]="customerCtrl">
                    <mat-autocomplete #autoCustomer="matAutocomplete"
                        (optionSelected)="customerSelected($event,customerAutoCompleteInput )">
                        <mat-option *ngFor="let customer of filteredCustomers | async" [value]="customer">
                            <span>{{ customer.Title }}</span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field class="col-lg-4">

                    <input matInput (focus)="focus(2)" #jobSiteAutoCompleteInput placeholder="{{'JobSite' | translate | async}}" required
                        aria-label="jobsite" [matAutocomplete]="autoJobsite" [formControl]="jobsiteCtrl">

                    <!-- [displayWith]="jobsiteDisplayMapper" -->
                    <mat-autocomplete #autoJobsite="matAutocomplete"
                        (optionSelected)="jobsiteSelected($event, jobSiteAutoCompleteInput)">
                        <mat-option *ngFor="let jobsite of filteredJobsites | async" [value]="jobsite">
                            <!--<img style="vertical-align:middle;" aria-hidden src="" height="25" />-->
                            <span>{{ jobsite.Title }}</span>
                            <small></small>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field class="col-lg-4">

                    <input matInput (focus)="focus(5)" #makeAutoCompleteInput placeholder="{{'Make' | translate | async}}"
                        aria-label="Make" [matAutocomplete]="autoMake" [formControl]="makeCtrl">

                    <mat-autocomplete #autoMake="matAutocomplete"
                        (optionSelected)="makeSelected($event,makeAutoCompleteInput )">
                        <mat-option *ngFor="let make of filteredMakes | async" [value]="make">
                            <span>{{ make.Title }}</span> |
                            <small>{{make.Symbol}}</small>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <!-- <mat-form-field class="col-lg-4">

          <input matInput (focus)="focus(4)" #familyAutoCompleteInput placeholder="{{ Translate('Family')}}"
            aria-label="Family" [matAutocomplete]="autoFamily" [formControl]="familyCtrl">

          <mat-autocomplete #autoFamily="matAutocomplete"
            (optionSelected)="familySelected($event,familyAutoCompleteInput)">
            <mat-option *ngFor="let family of filteredFamilies | async" [value]="family">
              <span>{{ family.Title }}</span> |
              <small>{{family.Symbol}}</small>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field> -->
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <mat-form-field class="col-lg-4 text-width">
                    <mat-select placeholder="{{'Base Model' | translate | async}}" name="BaseModel_" [(ngModel)]="selectedBaseModel"
                        #BaseModel_="ngModel">
                        <!-- (selectionChange)="changePartNumber($event)" -->
                        <mat-option [value]="type.Id" *ngFor="let type of baseModelList">
                            {{type.Title}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div class="row">

            <div class="col-lg-12" style="text-align: end;">
                <button mat-raised-button (click)="resetFields()"> {{'Reset' | translate | async}} </button>

                <button mat-raised-button color="warn" (click)="GetForecastConfigurationData()"
                    style="margin-left: 20px;margin-right: 20px;">
                    {{'Search' | translate | async}}
                </button>
            </div>
        </div>

    </mat-card>


    <div class="row">
        <div class="col-lg-4">

            <div class="table-row row" style="margin-top: 10px;    margin-left: 16px;" *ngIf="TableShow">

                <mat-card class="mat-card">
                    <div style="text-align: right; color:green;font-size:20px">
                        <mat-icon (click)="ConfigurationSectionOpen(1)">add</mat-icon>
                    </div>
                    <div style="text-align: center;margin-left:50%">
                        <mat-spinner *ngIf="graphLoader" class=""></mat-spinner>
                    </div>



                    <table class="table table--striped table--full-width">
                        <thead>
                            <tr class="table-row">
                                <th>{{'Customer' | translate | async}}</th>
                                <th>{{'Jobsite' | translate | async}}</th>
                                <th>{{'Make' | translate | async}}</th>
                                <th>{{'Model' | translate | async}}</th>
                                <th>{{'Unit #' | translate | async}}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <!-- Loop through your items -->
                            <tr *ngFor="let item of ForecastConfigurationVM" style="cursor:pointer">
                                <td (click)="OnRowCLick(item.WearRateId,item.ModelName)">{{item.CustomerName}}</td>
                                <td (click)="OnRowCLick(item.WearRateId,item.ModelName)">{{item.Jobsite}}</td>
                                <td (click)="OnRowCLick(item.WearRateId,item.ModelName)">{{item.Make}}</td>
                                <td (click)="OnRowCLick(item.WearRateId,item.ModelName)">{{item.ModelName}}</td>
                                <td (click)="OnRowCLick(item.WearRateId,item.ModelName)">{{item.UnitNumber}}</td>
                                 <td ><mat-icon (click)="ConfigurationSectionOpen(1,item)">edit</mat-icon></td>
                            </tr>
                        </tbody>
                    </table>
                    <div *ngIf="ForecastConfigurationVM.length === 0" class="no-data">{{'No data available' | translate | async}}</div>
                </mat-card>
            </div>
        </div>
        <div class="col-lg-8">
            <div class="table-row row" style="margin-top: 10px;margin-left: 8px;
    margin-right: 1px;" *ngIf="componentTable">

                <mat-card class="mat-card">
                    <div style="text-align: right; color:green;font-size:20px">
                        <mat-icon (click)="ConfigurationSectionOpen(2,null)">add</mat-icon>
                    </div>

                                        <table class="table table--striped table--full-width">
                        <thead>
                            <tr>
                                <th rowspan="2">{{'Component' | translate | async}}</th>
                                <th rowspan="2">{{'Compart' | translate | async}}</th>
                                <th rowspan="2">{{'Position' | translate | async}}</th>
                                <th colspan="2">{{'Winter' | translate | async}}</th>
                                <th colspan="2">{{'Summer' | translate | async}}</th>
                                <th colspan="2">{{'Shoulder' | translate | async}}</th>
                                <th colspan="2">{{'D' | translate | async}}</th>
                            </tr>
                            <tr>
                                <th>{{'CMU' | translate | async}}/%</th>
                                <th>{{'DOC' | translate | async}}/%</th>
                                <th>{{'CMU' | translate | async}}/%</th>
                                <th>{{'DOC' | translate | async}}/%</th>
                                <th>{{'CMU' | translate | async}}/%</th>
                                <th>{{'DOC' | translate | async}}/%</th>
                                <th>{{'CMU' | translate | async}}/%</th>
                                <th>{{'DOC' | translate | async}}/%</th>
                            </tr>
                        </thead>

                        <tbody>
                            <ng-container *ngFor="let item of ForecastingComponentWearRateGroupViewModel">
                                <tr class="component-row">
                                    <td colspan="12" class="component">{{ item.CompartType }}</td>
                                </tr>
                                <tr *ngFor="let compart of item.Comparts">
                                    <td></td>
                                    <td>{{ compart.Compart }}</td>

                                    <td><span *ngIf="compart.PositionName!='0'"> {{ compart.PositionName }}</span></td>

                                    <!-- Winter -->
                                    <!-- Winter -->
                                    <td>
                                        <mat-form-field class="small-input">
                                            <input matInput type="number" [(ngModel)]="compart.Weathers[0].AvgCmu"
                                                (focusout)="onAvgDocFocusOut(compart.Weathers[0].AvgCmu, compart.Weathers[0].Id,1)"
                                                placeholder="CMU" />
                                        </mat-form-field>
                                    </td>
                                    <td>
                                        <mat-form-field class="small-input">
                                            <input matInput type="number" [(ngModel)]="compart.Weathers[0].AvgDoc"
                                                (focusout)="onAvgDocFocusOut(compart.Weathers[0].AvgDoc, compart.Weathers[0].Id,2)"
                                                placeholder="DOC" />
                                        </mat-form-field>
                                    </td>

                                    <!-- Summer -->
                                    <td>
                                        <mat-form-field class="small-input">
                                            <input matInput type="number" [(ngModel)]="compart.Weathers[1].AvgCmu"
                                                (focusout)="onAvgDocFocusOut(compart.Weathers[1].AvgCmu, compart.Weathers[1].Id,1)"
                                                placeholder="CMU" />
                                        </mat-form-field>
                                    </td>
                                    <td>
                                        <mat-form-field class="small-input">
                                            <input matInput type="number" [(ngModel)]="compart.Weathers[1].AvgDoc"
                                                (focusout)="onAvgDocFocusOut(compart.Weathers[1].AvgDoc, compart.Weathers[1].Id,2)"
                                                placeholder="DOC" />
                                        </mat-form-field>
                                    </td>

                                    <!-- Shoulder -->
                                    <td>
                                        <mat-form-field class="small-input">
                                            <input matInput type="number" [(ngModel)]="compart.Weathers[2].AvgCmu"
                                                placeholder="CMU"
                                                (focusout)="onAvgDocFocusOut(compart.Weathers[2].AvgCmu, compart.Weathers[2].Id,1)" />
                                        </mat-form-field>
                                    </td>
                                    <td>
                                        <mat-form-field class="small-input">
                                            <input matInput type="number" [(ngModel)]="compart.Weathers[2].AvgDoc"
                                                (focusout)="onAvgDocFocusOut(compart.Weathers[2].AvgDoc, compart.Weathers[2].Id,2)"
                                                placeholder="DOC" />
                                        </mat-form-field>
                                    </td>

                                    <!-- D -->
                                    <td>
                                        <mat-form-field class="small-input">
                                            <input matInput type="number" [(ngModel)]="compart.Weathers[3].AvgCmu"
                                                (focusout)="onAvgDocFocusOut(compart.Weathers[3].AvgCmu, compart.Weathers[3].Id,1)"
                                                placeholder="CMU" />
                                        </mat-form-field>
                                    </td>
                                    <td>
                                        <mat-form-field class="small-input">
                                            <input matInput type="number" [(ngModel)]="compart.Weathers[3].AvgDoc"
                                                (focusout)="onAvgDocFocusOut(compart.Weathers[3].AvgDoc, compart.Weathers[3].Id,2)"
                                                placeholder="DOC" />
                                        </mat-form-field>
                                    </td>

                                </tr>
                            </ng-container>
                        </tbody>
                    </table>

                    <div *ngIf="ForecastConfigurationVM.length === 0" class="no-data">{{'No data available' | translate | async}}</div>
                </mat-card>
            </div>
        </div>
    </div>
</div>